import { DesktopMenuItem } from '@/widgets/Navbar/DesktopMenu/models';
import { MenuItems } from '@/widgets/Navbar/MobileMenu/models';

import { checkoutCartPage, home, servicePage, user, userProfile } from '@/constants/routes';

import { HomeIcon } from '../../../components/icons/HomeIcon';
import { ProfileIcon } from '../../../components/icons/ProfileIcon';

import { Element4, ShoppingCart } from 'iconsax-react';

export const mobileMenuItemsList: MenuItems[] = [
    {
        id: 1,
        title: 'خانه',
        icon: <HomeIcon className='h-5 w-5' />,
        link: home,
        matchPaths: [home]
    },
    {
        id: 2,
        title: 'خدمات',
        icon: <Element4 size={20} color='currentColor' variant='Outline' />,
        link: servicePage,
        matchPaths: [servicePage],
        prefetch: false
    },
    {
        id: 3,
        title: 'سبد خرید',
        icon: <ShoppingCart size={20} color='currentColor' variant='Outline' />,
        link: checkoutCartPage,
        matchPaths: ['/checkout']
    },
    {
        id: 4,
        title: 'پروفایل',
        icon: <ProfileIcon className='h-5 w-5' />,
        link: `${userProfile}/`,
        matchPaths: [user],
        prefetch: false
    }
];

export const desktopMenuItems: DesktopMenuItem[] = [
    {
        id: 2,
        title: 'درباره ما',
        link: '/about-us'
    },
    {
        id: 3,
        title: 'تماس با ما',
        link: '/contact'
    },
    {
        id: 4,
        title: 'بلاگ',
        link: '/blog'
    },
    {
        id: 5,
        title: 'در ازکی‌سرویس بفروشید!',
        link: '/vendor'
    }
];
